import type { LoaderFunctionArgs } from '~/types/route-args';
import { findPlaceByKeyword } from '@modules-rocco/location/api/find-place-by-keyword.server';
import type { FindPlaceApiProviderEnum } from 'generated/graphql';

export const FIND_PLACE_BY_KEYWORD_ACTION =
    '/actions/location/find-place-by-keyword';

export const loader = async (args: LoaderFunctionArgs) => {
    const { request, context } = args;

    const url = new URL(request.url);

    // Passed through as a code. Which countries have address data is the server's answer
    // now, so filtering here against a fixed list would hide a newly imported country.
    const addressCountry = (
        url.searchParams.get('country') || context.localisation.country
    )
        .trim()
        .toUpperCase();

    return findPlaceByKeyword(
        {
            keyword: url.searchParams.get('keyword') ?? '',
            type: url.searchParams.get('type') ?? '',
            limit: parseInt(url.searchParams.get('limit') ?? '10'),
            country: addressCountry,
            apiProvider: url.searchParams.get('apiProvider') as
                | FindPlaceApiProviderEnum
                | undefined,
        },
        context,
    );
};
